import { render, staticRenderFns } from "./ColourDetailPage.vue?vue&type=template&id=00b1826e"
import script from "./ColourDetailPage.vue?vue&type=script&lang=js"
export * from "./ColourDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ColourDetailPage.vue?vue&type=style&index=0&id=00b1826e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports